module.exports = __webpack_public_path__ + "static/rewards-card-xbox-game-pass-245268e8305b3a39e585537332e3fa80.png";